export const linkedInProfileRegex = /^(https?:\/\/)?(\w+\.)?linkedin.com\/in\/([-a-zA-Z0-9]+)/
export const LOCALIZATION_KEY = 'builder.prefill_resume.create_resume_with_linkedin'
